import _ from 'lodash'
import api from '../../api'
import router from '../../router'
import socket from '../../plugins/socketIO'

export const splashScreenEnum = {
  WAITING_FOR_NEXT_ROUND: 'WAITING_FOR_NEXT_ROUND',
  ROUND_IS_ENDING: 'ROUND_IS_ENDING',
  NEW_ROUND_STARTING: 'NEW_ROUND_STARTING',
  GAME_IS_COMPUTING: 'GAME_IS_COMPUTING',
  GAME_IS_LOADING: 'GAME_IS_LOADING',
  GAME_IS_ENDING: 'GAME_IS_ENDING',
  GAME_END_RESULT: 'GAME_END_RESULT',
}

const defaultState = () => ({
  games: [],
  notActiveGames: [],
  archivedGames: [],
  currentGameId: null,
  splashScreenStateOwner: null,
  teamFinanceOwner: [],
  teamFinanceOwnerDetail: [],
  allPlayers: [],
  allUsers: [] //Pro všechny uživatele na adgame, ne jen ve hře
})

export default {
  defaultState,
  state: defaultState,
  getters: {
    myOwnedActivateGames: state => state.games,
    myOwnedActivateDemoGames: state => state.games.filter(game => game.type == "DEMO"),
    myOwnedArchivedGames: state => state.archivedGames,
    currentGameId: state => state.currentGameId,
    splashScreenStateOwner: state => state.splashScreenStateOwner,
    myOwnedGames: state => state.notActiveGames.filter(game => !game.startedTime && game.turn == 0),
    allPlayers: state => state.allPlayers,
    allUsers: state => state.allUsers, //Všichni uživatelé na adgame, ne jen ve hře
    teamFinancialOverviewOwner: state => state.teamFinanceOwner,
    teamFinancialOverviewOwnerDetail: state => state.teamFinanceOwnerDetail,
    ownerCurrentGame: (state, getters) => state.currentGameId === _.get(getters, 'activeGame.id')
      ? getters.activeGame
      : state.games.find(game => game.id === state.currentGameId),
    imIOwner: (state, getters) => !!getters.ownerCurrentGame
  },
  actions: {
    updateOwnerGame({ commit, getters }, data) {
      commit('UPDATE_GAME', { id: getters.activeGame.id, ...data } || getters.activeGame)
    },
    removeOwnerActiveGame({ commit, getters }) {
      commit('REMOVE_GAME', getters.activeGame.id)
    },
    async startGame({ getters, dispatch }) {
      dispatch('toggleLoader', true)
      const gameId = getters.ownerCurrentGame.id
      try {
        await api.gameOwner.startGame(gameId)
      } catch (e) {
        console.log(e)
      }
    },
    async readyDemoGame({ getters, dispatch }, wait = true) {
      dispatch('toggleLoader', true)
      try {
        await api.game.readyUserInGame(wait)
      } catch (e) {
        console.log(e)
      }
    },
    async activateGame({ getters, dispatch }) {
      dispatch('toggleLoader', true)
      const gameId = getters.ownerCurrentGame.id
      try {
        console.log("AKtivuji")
        await api.gameOwner.activateGame(gameId)
        this.$toast.success(`The game has been activated`)
      } catch (e) {
        console.log(e)
      }
      dispatch('toggleLoader', false)
    },
    async fetchOwnGames({ commit }) {
      const { data } = await api.gameOwner.findAllNotActiveGamesForOwner()
      console.log(data)
      commit('SET_GAMES_OWNER', data)
    },
    async fetchOwnActiveGames({ commit }) {
      const { data } = await api.gameOwner.findAllActiveGamesForOwner()

      await commit('SET_ACTIVE_GAMES', data)
    },
    async fetchOwnArchivedGames({ commit }) {
      const { data } = await api.gameOwner.findAllArchivedGamesForOwner()
      commit('SET_ARCHIVED_GAMES', data)
    },
    async createGame({ getters, dispatch }, game) {
      dispatch('toggleLoader', true)
      try {
        const { data: gameId } = await api.gameOwner.create(game);
        console.log("creategame")
        await dispatch('fetchMe')
        await dispatch('fetchOwnGames')
        await dispatch('fetchOwnActiveGames')
        await dispatch('fetchOwnArchivedGames')
      } catch (e) {
        this.showError(e)
      }
      dispatch('toggleLoader', false)
    },
    async createGameAndActivate({ getters, dispatch }, game) {
      dispatch('toggleLoader', true)
      try {
        const { data: gameId } = await api.gameOwner.create(game);
        await dispatch('fetchMe')
        await dispatch('fetchOwnGames')
        await dispatch('fetchOwnActiveGames')
        await dispatch('fetchOwnArchivedGames')
        //return gameId;
        var createdGame = await dispatch('getCreatedGame', gameId);
        console.log("Ta hra je: ");
        console.log(createdGame);
        await dispatch('setOwnerCurrentGameId', createdGame);
        if (!createdGame.active && createdGame.startedTime == null) {
          await dispatch("activateGame");
          await dispatch("fetchOwnGames");
          await dispatch("fetchOwnActiveGames");
          await dispatch("fetchMe");
        } 
      } catch (e) {
        this.showError(e)
      }
      dispatch('toggleLoader', false)
    },
    async getCreatedGame({ getters, dispatch, state }, id){
      var createdGame = await state.notActiveGames.find(x => x.id === id);
      return createdGame;
    },
    async setOwnerCurrentGameId({ commit, dispatch, getters }, game) {
      dispatch('toggleLoader', true)
      commit('SET_MY_GAME', game)
      if (game.startedTime || !game.active) {
        await dispatch('fetchActiveGame')
        if (game.startedTime) {

          await dispatch('fetchAllTeams')
          await dispatch('fetchFinancialOverview')
          await dispatch('fetchTeamRanking')
          await dispatch('fetchAllPlayers')
        }
      }
      commit('SET_CURRENT_GAME_ID', game.id)
      await socket.waitForConnection()
      await socket.unsubscribe()
      if (!getters.joinedGame.endedTime) {
        await socket.subscribeGame(game.id)
      }
      //CHARTS data
      dispatch('fetchAllGameProducts')
      dispatch('fetchAllPurchasedData')
      dispatch('fetchGameProductsSales')
      dispatch('fetchGameCampaigns')

      dispatch('toggleLoader', false)
    },
    async postponeRound({ getters, dispatch }, seconds) {
      dispatch('toggleLoader', true)
      try {
        await api.gameOwner.postponeTurn({
          gameId: getters.ownerCurrentGame.id,
          seconds
        })
      } catch (e) {
        console.log(this.$t(`${e.response.data.validationErrors[0].attribute} ${e.response.data.validationErrors[0].msg}`) || 'Oops! Something went wrong!');  
      }
      dispatch('toggleLoader', false)
    },
    async endCurrentTurn({ getters, dispatch }) {
      dispatch('toggleLoader', true)
      try {
        await api.gameOwner.endTurnManually(getters.ownerCurrentGame.id)
        this.$toast.success('Current turn was ended.')
      } catch (e) {
        console.log(e)
      }
      dispatch('toggleLoader', false)
    },
    async endGame({ getters }, seconds) {
      try {
        await api.gameOwner.endGameManually(getters.ownerCurrentGame.id)
      } catch (e) {
        console.log(e)
      }
    },
    async deleteGame({ getters, dispatch }) {
      dispatch('toggleLoader', true)
      try {
        await api.gameOwner.delete(getters.ownerCurrentGame.id)
      } catch (e) {
        console.log(e)
      }
      dispatch('toggleLoader', false)
    },
    async updateGame({ dispatch, getters }, game) {
      dispatch('toggleLoader', true)
      try {
        await api.gameOwner.updateInGame({ game, id: getters.ownerCurrentGame.id })
      } catch (e) {
        console.log(`${e.response.data.validationErrors[0].attribute} ${e.response.data.validationErrors[0].msg}`);  
      }
      dispatch('toggleLoader', false)
    },
    async downloadGameOwnerData({ commit }, id) {
      try {
        const answer = await api.gameOwner.downloadGameOverview(id)
        const url = window.URL.createObjectURL(new Blob([answer.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', answer.headers['content-disposition'].split('filename=')[1]);
        document.body.appendChild(link);
        link.click();
      }
      catch (e) {
        console.log(e)
      }
    },
    async fetchTeamFinanceOwner({ commit }, id) {
      const team = id
      if (team) {
        try {
          const { data } = await api.gameData.financeOverview(team)
          commit('SET_TEAM_FINANCE', data)
        } catch (e) {
          console.log(e)
        }
      }
    },
    async fetchTeamFinanceOwnerDetail({ commit }, id) {
      const team = id
      if (team) {
        try {
          const { data } = await api.gameOwner.findAllTeamTransactionsByTeamId(team)
          commit('SET_TEAM_FINANCE_DETAIL', data)
        } catch (e) {
          console.log(e)
        }
      }
    },
    async fetchAllPlayers({ getters, commit }) {
      try {
        const { data } = await api.user.findAll(getters.activeGame.id)
        commit('SET_PLAYER_LIST', data)
      } catch (e) {
        console.log(e)
      }
    },
    async fetchAllUsers({ getters, commit }) {
      try {
        const { data } = await api.user.getAllUsers()
        console.log("Načítám usery")
        console.log(data)
        commit('SET_ALL_USERS', data)
      } catch (e) {
        console.log(e)
      }
    },
    async deactivateUser({dispatch }, user) {
      try {
        const { data } = await api.user.deactivate(user)
        await dispatch('fetchAllUsers')
        this.$toast.success('User deactivated')
      } catch (e) {
        console.log(e)
      }
    },
    async activateUser({dispatch }, user) {
      try {
        const { data } = await api.user.activate(user)
        this.$toast.success('User activated')
        await dispatch('fetchAllUsers')
      } catch (e) {
        console.log(e)
      }
    },
    async changeRole({dispatch }, {id, role}) {
      try {
        console.log("Jaká role")
        console.log(role)
        const { data } = await api.user.changeRole({id: id,role: role})
        this.$toast.success('Role changed')
        await dispatch('fetchAllUsers')
      } catch (e) {
        console.log("Admin cannot change role of another admin")
      }
    },

    async getPlayersByEmail({ getters, commit }, email) {
      try {
        const { data } = await api.user.findByEmail(email)
        return data
      } catch (e) {
        console.log(e)
      }
    },
    async getPlayersByUsername({ getters, commit }, username) {
      try {
        const { data } = await api.user.findByUsername(username)
        return data
      } catch (e) {
        console.log(e)
      }
    },
    async getPlayersBySearch({ getters, commit }, username) {
      try {
        const { data } = await api.user.findByBoth(username)
        return data
      } catch (e) {
        console.log(e)
      }
    },
    async addPlayerToGame({ dispatch }, data) {
      try {
        await api.gameOwner.addPlayerToGame(data.user, data.team)
        await dispatch('fetchAllPlayers')
        this.$toast.success('Player added')
      } catch (e) {
        console.log(e.response.data.msg)
        console.log("User cannot be added to this game")
      }
    },
    async SOCKET_TURN_END({ commit, dispatch }) {
      commit('SET_SPLASH_SCREEN_STATE', splashScreenEnum.ROUND_IS_ENDING)
      commit('SET_COMPUTING', true)
      dispatch('toggleLoader', true)
    },
    /*async SOCKET_GAME_READY({ commit, dispatch }) {
      commit('CLEAR_SPLASH_SCREEN_STATE')
      commit('SET_COMPUTING', false)
      dispatch('toggleLoader', false)
    },*/
    async SOCKET_GAME_START({ getters, dispatch }) {
      if (getters.imIOwner) {
        await dispatch('fetchActiveGame')
        await dispatch('fetchAllTeams')
        await dispatch('fetchFinancialOverview')
        await dispatch('fetchTeamRanking')
        await dispatch('fetchAllPlayers')
        dispatch('updateOwnerGame')
        dispatch('fetchAllGameProducts')
        dispatch('fetchGameProductsSales')
        dispatch('fetchGameCampaigns')
        dispatch('fetchAllPurchasedData')
        await router.push({name: 'GameManager.game.overview'})
      }
    },
    SOCKET_TURN_START({ commit, getters, dispatch }, data) {
      commit('SET_SPLASH_SCREEN_STATE', splashScreenEnum.NEW_ROUND_STARTING)
    }
  },
  mutations: {
    SET_SPLASH_SCREEN_STATE(state, value) {
      state.splashScreenStateOwner = value
    },
    CLEAR_SPLASH_SCREEN_STATE(state) {
      state.splashScreenStateOwner = null
    },
    SET_GAMES_OWNER(state, data) {
      state.notActiveGames = data
    },
    SET_ACTIVE_GAMES(state, data) {
      state.games = data
    },
    SET_ARCHIVED_GAMES(state, data) {
      state.archivedGames = data
    },
    SET_TEAM_FINANCE(state, data) {
      state.teamFinanceOwner = data || []
    },
    SET_TEAM_FINANCE_DETAIL(state, data) {
      state.teamFinanceOwnerDetail = data || []
    },
    SET_CURRENT_GAME_ID(state, gameId) {
      state.currentGameId = gameId
    },
    SET_PLAYER_LIST(state, data) {
      state.allPlayers = data
    },
    SET_ALL_USERS(state, data) {
      console.log("Načítám usery #2")
        console.log(data)
      state.allUsers = data
    },
    UPDATE_GAME(state, data) {
      state.games = state.games.map(game => {
        if (game.id === data.id) {
          return {
            ...game,
            ...data
          }
        }
        return game
      })
    },
    REMOVE_GAME(state, gameId) {
      state.games = state.games.filter(game => game.id !== gameId)
    },
  },
}

